<template>
  <v-container fluid>
    <v-row v-if="isTrialPlan">
      <v-col>
        <v-icon
          color="#d6c000"
        >
          mdi-lock-open
        </v-icon>
          <a href="https://dx-e.net/trial-to-standard/" target="_blank">スタンダードプランへのアップグレードはこちら</a>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <dashboard-failure-report />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="8">
        <dashboard-collect-chart />
      </v-col>
      <v-col cols="12" md="4">
        <dashboard-drafting-chart />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="8">
        <dashboard-report-summary />
      </v-col>
      <v-col cols="12" md="4">
        <div v-if="isAllocate">
          <dashboard-driver-status :target-date="today" />
        </div>
        <div v-else>
          <v-card flat class="rounded-card">
            <v-img
              max-height="300"
              contain
              :src="require(`@/assets/images/manual_menu.png`)"
            />
          </v-card>
        </div>
      </v-col>
    </v-row>

    <!-- /DXE_JWNET起票件数／回収件数/ドライバーステータス -->
  </v-container>
</template>

<script>
import DashboardCollectChart from './report/_CollectChart'
import DashboardDraftingChart from './report/_DraftingChart'
import DashboardReportSummary from './report/_Summary'
import DashboardDriverStatus from './report/_DriverStatus'
import DashboardFailureReport from './report/_FailureReport'
import {mapActions, mapGetters, mapState} from "vuex";

export default {
  name: 'DriverDashboardIndex',
  components: {
    DashboardFailureReport,
    DashboardCollectChart,
    DashboardDraftingChart,
    DashboardReportSummary,
    DashboardDriverStatus,
  },
  mixins: [],
  data () {
    return {
      systemTime: this.$dayjs(),
      today: null,
    }
  },
  computed: {
    ...mapGetters('DriverAuthentication', [
      'isSuperSupportUser',
    ]),
    ...mapState('DriverTenantConfiguration', {
      isAllocate: 'use_allocate',
      isTrialPlan: 'use_trial_plan',
    }),
  },
  watch: {
  },
  created() {
    this.today = this.systemTime.format('YYYY-MM-DD')
  },
  methods: {
    ...mapActions('DriverTenantConfiguration', {
      fetch: 'show',
    })
  }
}
</script>
